import React, { createContext } from 'react';
import { ISellerJson } from './seller.interface';
import {ISite} from "../sites/site.interface";

interface SellerContextProps {
    chosenSeller: ISellerJson | null;
    setChosenSeller: React.Dispatch<React.SetStateAction<ISellerJson | null>>;
    currentSeller: ISellerJson | null;
    setCurrentSeller: React.Dispatch<React.SetStateAction<ISellerJson | null>>;
    site: ISite;
}

export const SellerContext = createContext<SellerContextProps>({
    chosenSeller: null,
    setChosenSeller: () => {},
    currentSeller: null,
    setCurrentSeller: () => {},
    site: null,
});

